import React, { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import UserLoginContext from "../../../context/userLoginContext";
import LoginView from "./login.view";
import server from "../../../server";
import { message } from "antd";
import { DecodedToken, LoginFormData, LoginResponse, SaveToken } from "./type/login.type";
import { setToken } from "../../../services/tokenService";
import "../../../styles/component/auth/login.scss";


const Login = () => {
    const navigate = useNavigate();
    const {tokenToUserData} = useContext(UserLoginContext);
    const [rememberMe, setRememberMe] = useState<boolean>(false);
    const location = useLocation();



    async function onSubmit(formData: LoginFormData) {
        try {

            const from = location.state?.from?.pathname || "/dashboard";
            const response: LoginResponse = await server.auth.login(formData);

            if (!response?.refreshToken || typeof response.refreshToken !== "string") {
                message.error("Invalid login response");
                return;
            }

            let decoded: DecodedToken;

            try {
                decoded = jwtDecode(response.refreshToken);
            } catch {
                message.error("Invalid token received from server");
                return;
            }

            const expInMilliSeconds = (decoded?.exp ?? 0) * 1000;

            const saveToken: SaveToken = {
                token: response.refreshToken,
                exp: expInMilliSeconds
            };

            setToken(saveToken);

            if (response.id) {
                localStorage.setItem("id", JSON.stringify(response.id));
            }

            await tokenToUserData();

            console.log(location.state);
            navigate(from, {replace: true});

        } catch (err) {
            message.error("Login failed. Please try again.");
            console.error(err);
        }
    }


    function handleRememberMeLogic(val: boolean) {
        setRememberMe(val);
    }

    return (
        <LoginView onSubmit={onSubmit} handleRememberMeLogic={handleRememberMeLogic}/>
    );
}

export default Login;
